module.exports = __webpack_public_path__ + "media/stable/components/foundation/base/assets/polygon_badge_review-05f51b4a5a9a372dd0395a035ab7a3b7.svg";